import React, { createContext, useContext, useState, ReactNode } from 'react';

type Language = 'PL' | 'ENG';

interface LanguageContextProps {
  language: Language;
  setLanguage: (lang: Language) => void;
  // A simple translation dictionary function for later use
  t: (key: string) => string;
}

const translations = {
  PL: {
    comingSoon: 'Treść wkrótce',
  },
  ENG: {
    comingSoon: 'Coming soon',
  },
};

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>('PL');

  const t = (key: string) => {
    return translations[language][key as keyof typeof translations['PL']] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
